import { jsonp, ajax } from '@ifeng/ui_base';
import { formatImage, formatUrl } from '@ifeng/public_method';
import { getSkey, handleNewstime } from '../utils/utils';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const md5 = require('md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

/* 公共 */

// 获取调查数据
const getSurveyData = async id => {
    const { schemaCheck } = await import('./validate');

    console.log(id);

    let data = await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: 'getSurveyData',
        cache: false,
    });
    const requestUrl = `sv.ifeng.com/index.php/survey/getdata?id=${id}&callback=getSurveyData`;

    data = schemaCheck(data, 'surveyDataSchema', requestUrl);

    return data ? data : null;
};

/**
 *  时尚首页
 */

/**
 * 音乐首页
 * @param {String} dataType 数据类型: yueNews, yueAi, yueNishizhen
 */
const getYueNews = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueNews`, {
        jsonpCallback: 'getYueNews',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 10);

    return result ? result : null;
};
const getYueAi = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueAi`, {
        jsonpCallback: 'getYueAi',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 15);

    return result ? result : null;
};
const getYueNishizhen = async dataType => {
    const data = await jsonp(`${apiBaseUrl}/yue/index/${dataType}/getYueNishizhen`, {
        jsonpCallback: 'getYueNishizhen',
        cache: 120,
    });

    const dataArr = data.data.data;

    const result = dataArr.slice(0, 12);

    return result ? result : null;
};
// 获取文章评论数
const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

export { getSurveyData, getYueNews, getYueAi, getYueNishizhen, getCommentCount };
